import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IDocumentReaderPartUrlsResponse } from './types';

/** Signed PUT URLs for some parts of one file. They expire after an hour and are never stored. */
export async function requestDocumentReaderPartUrls(
  uploadId: string,
  fileId: string,
  partNumbers: readonly number[],
  signal?: AbortSignal
): Promise<CommendaAiMutationResult<IDocumentReaderPartUrlsResponse>> {
  return AgentApiRequestHelper.mutate<IDocumentReaderPartUrlsResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}/files/${encodeURIComponent(fileId)}/part-urls`,
    { method: 'POST', body: { partNumbers }, ...(signal ? { signal } : {}) },
    'Could not prepare the next parts of this file.'
  );
}
